/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-03-15 10:14:03
 * @LastEditors: sj
 * @LastEditTime: 2022-06-14 15:39:42
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  ModalProps,
  notification,
  Row,
  Select,
  Space,
} from 'antd'
import React, { ReactElement, useState, useEffect, useContext } from 'react'
import { useDispatch } from 'react-redux'
import {
  editInvoiceAsync,
  getInvoiceSupplierList, getInvoiceUrl, invoiceDetailAsync,
} from './TenentSettingSlice'
import 'moment/locale/zh-cn'
import { UndoOutlined } from '@ant-design/icons'
import styles from './TenantSetting.module.css'
import { ThemeContext } from '../../../theme/ThemeContext'

export interface SettingProps {
  tenantId: string
  id?: number
  onOk: () => void
  onCancel: () => void
}

export const InvoiceModal = ({
  tenantId,
  id,
  onOk,
  onCancel,
  visible,
}: ModalProps & SettingProps): ReactElement => {

  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<any>()

  const [form] = Form.useForm()

  const { Option } = Select

  const [loading, setLoading] = useState(false)

  const [status, setStatus] = useState(true)

  const [url, setUrl] = useState('')

  const [invoiceOptions, setInvoiceOptions] = useState<any>([])

  const [okbtn, setOkbtn] = useState(true)

  const [ids, setIds] = useState('')

  const layout = {
    labelCol: { span: 12 },
    wrapperCol: { span: 12 },
  }

  const FormatLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  }

  const loadingbtn = () => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }

  useEffect(() => {
    if (visible && id) {
      detail()
    }
  }, [visible])

  useEffect(() => {
    dispatch(getInvoiceSupplierList()).then(unwrapResult).then((data: any) => {
      setInvoiceOptions(data)
    })
  }, [])

  const detail = () => {
    if (form.getFieldValue('supplierId') || id) {
      const data = {
        tenantId,
        supplierId: form.getFieldValue('supplierId'),
        id
      }
      dispatch(invoiceDetailAsync(data)).then(unwrapResult).then((res: any) => {
        if (res.length) {
          form.setFieldsValue({
            ...res[0]
          })
          setStatus(res[0]?.status === 1)
          setIds(res[0]?.id)
          setOkbtn(false)
        } else {
          notification.error({
            message: '请先进行授权操作'
          })
        }
      })
    } else {
      notification.error({
        message: '请先选择发票供应商'
      })
    }
  }

  const save = () => {
    const data = { ...form.getFieldsValue(), tenantId, id: ids || id, status: status ? 1 : 0 }
    console.log(data);
    dispatch(editInvoiceAsync(data)).then(unwrapResult).then(() => {
      onOk()
      close()
    })
  }

  const close = () => {
    form.resetFields()
    setUrl('')
    setOkbtn(true)
    onCancel()
    setIds('')
  }
  return (
    <Modal
      title={(id ? '修改' : '开通') + '电子发票'}
      visible={visible}
      width='900px'
      onOk={() => {
        loadingbtn()
      }}
      footer={null}
      onCancel={() => {
        close()

      }}
      confirmLoading={loading}
    >
      <Form
        {...layout}
        form={form}
      >
        <Row gutter={20}>
          <Col span={18}>
            <Form.Item name='supplierId' label='电子发票供应商' {...FormatLayout}>
              <Select placeholder='请选择发票供应商' onChange={(e) => {
                console.log(e, tenantId);
                const data = {
                  supplierId: e as number || 0,
                  tenantId
                }
                dispatch(getInvoiceUrl(data)).then(unwrapResult).then((data: any) => {
                  setUrl(data)
                })
              }}>
                {
                  invoiceOptions.length && invoiceOptions.map((v: any) => {
                    return <Option value={v.id} key={v.id}>
                      {v.supplierName}
                    </Option>
                  })
                }
              </Select>
            </Form.Item>
          </Col>
          <Col span={5}>
            <span style={{ float: 'right', cursor: 'pointer' }} onClick={() => {
              detail()
            }}>

            刷新签约结果<UndoOutlined />
            </span>
          </Col>

          <Col span={18}>
            <Form.Item name='' label='签约网址' required {...FormatLayout}>
              <span className={styles.invoice} style={{ color: theme.c1 }} onClick={() => {
                window.open(url, '_blank')
              }}>
                {url}
              </span>
            </Form.Item>
          </Col>

          <Col span={18}>
            <Form.Item name='supplierName' label='发票供应商' {...FormatLayout}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item name='taxNo' label='机构税号' {...FormatLayout}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item name='accessToken' label='机构token' {...FormatLayout}>
              <Input disabled />
            </Form.Item>
          </Col>

        </Row>
        <Row gutter={20}>
          <Col span={9}>
            <Form.Item name='' label='是否启用'>
              <Checkbox
                checked={status}
                onChange={() => {
                  setStatus(!status)
                }}
              >
                启用
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={20} justify='end'>
          <Space>

            <Button onClick={() => close()}>取消</Button>
            <Button type='primary' disabled={okbtn} onClick={() => save()}>确认</Button>
          </Space>
        </Row>
      </Form>
    </Modal>
  )
}
